export default __webpack_public_path__ + "static/media/autumn.cff26f80.jpg";